import {Observable} from "rxjs";
import {User} from "@app/core/user/domain/entities/user";
import {NewCostumerSignUpData} from "@app/core/user/domain/dtos/new-costumer-sign-up-data";
import {ActualCostumerSignUpData} from "@app/core/user/domain/dtos/actual-costumer-sign-up-data";
import {Credentials} from "@app/core/credentials/domain/credentials";
import {UpdateUserData} from "@app/core/user/domain/dtos/update-user-data";
import {EmployeeSignUpData} from "./dtos/employee-sign-up-data";

export abstract class UserRemote {

    public abstract login(credentials: Credentials, recaptchaToken?: string): Observable<User>;
    public abstract signUpNewCustomer(newCostumerSignUpData: NewCostumerSignUpData): Observable<User>;
    public abstract signUpActualCustomer(actualCostumerSignUpData: ActualCostumerSignUpData): Observable<User>;
    public abstract resetPassword(email: string, recaptchaToken: string): Observable<void>;
    public abstract updateUser(updateUserData: UpdateUserData): Observable<User>;
    public abstract signUpEmployee(employeeSignUpData: EmployeeSignUpData): Observable<void>;
    public abstract deleteAccount(): Observable<void>;
    public abstract getUser(): Observable<User | null>;
}
